let SendBsSendBtnSVG = () => {
  return (
    <svg width="46" height="30" viewBox="0 0 46 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="46" height="30" rx="15" fill="url(#paint0_linear_4810_8446)" />
      <g clipPath="url(#clip0_4810_8446)">
        <path
          d="M27.5282 8.17621L15.6132 12.8386C14.7876 13.1617 14.7595 14.3197 15.5685 14.6824L19.8811 16.6156C20.105 16.7159 20.2841 16.8951 20.3845 17.119L22.3177 21.4315C22.6804 22.2405 23.8384 22.2125 24.1615 21.3869L28.8239 9.47186C29.1416 8.65979 28.3403 7.85845 27.5282 8.17621Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_4810_8446" x1="0" y1="15" x2="46" y2="15" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B74FB" />
          <stop offset="0.505" stopColor="#6468F7" />
          <stop offset="1" stopColor="#9659F2" />
        </linearGradient>
        <clipPath id="clip0_4810_8446">
          <rect width="20" height="20" fill="white" transform="translate(13 5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

let UploadImgDefSVG = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 17L13 9L17 13" stroke="#131921" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11 3H4C3.44772 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16V9"
        stroke="#131921"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7.5" cy="7.5" r="1.5" fill="#131921" />
      <path d="M15 3L19 3" stroke="#131921" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17 5L17 1" stroke="#131921" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

let UploadFileDefSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M17 9V16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V4C3 3.44772 3.44772 3 4 3H7.58579C7.851 3 8.10536 3.10536 8.29289 3.29289L9.70711 4.70711C9.89464 4.89464 10.149 5 10.4142 5H12"
        stroke="#131921"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 3L19 3" stroke="#131921" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 13L10 13" stroke="#131921" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17 5L17 1" stroke="#131921" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

let MentINputDiffSVG = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2.02344C14.4047 2.02356 17.9755 5.59428 17.9756 9.99902C17.9755 11.226 17.6356 12.2978 17.1064 13.0967C16.6222 13.8276 15.9281 14.3984 15.1377 14.542L14.9775 14.5645C14.1635 14.6508 13.4034 14.2955 12.8906 13.5312C12.8047 13.4031 12.7263 13.2642 12.6553 13.1152C12.0148 13.8908 11.1063 14.3945 10.043 14.3945C7.9361 14.3942 6.43262 12.4204 6.43262 10.2607C6.43279 8.10124 7.93622 6.12824 10.043 6.12793C10.8732 6.12793 11.6094 6.43508 12.1973 6.93848C12.2966 6.64054 12.575 6.42488 12.9062 6.4248C13.3203 6.42492 13.6562 6.76074 13.6562 7.1748V10.3828C13.6563 11.6052 13.8846 12.3219 14.1357 12.6963C14.3592 13.0292 14.595 13.0971 14.8193 13.0732L14.9238 13.0537C15.1821 12.985 15.5349 12.754 15.8564 12.2686C16.2114 11.7327 16.4755 10.953 16.4756 9.99902C16.4755 6.42271 13.5763 3.52356 10 3.52344C6.42369 3.52356 3.52453 6.42271 3.52441 9.99902C3.52453 13.5753 6.42369 16.4745 10 16.4746C10.8755 16.4746 11.709 16.3018 12.4688 15.9883C12.8516 15.8303 13.2902 16.0127 13.4482 16.3955C13.6059 16.7782 13.4237 17.216 13.041 17.374C12.1029 17.7612 11.0753 17.9746 10 17.9746C5.59526 17.9745 2.02453 14.4038 2.02441 9.99902C2.02453 5.59428 5.59526 2.02356 10 2.02344ZM10.043 7.62793C8.99044 7.62827 7.93279 8.68419 7.93262 10.2607C7.93262 11.8375 8.99036 12.8942 10.043 12.8945C11.0957 12.8945 12.1543 11.8378 12.1543 10.2607C12.1541 8.68394 11.0957 7.62793 10.043 7.62793Z"
        fill="#131921"
      />
    </svg>
  )
}

let WanxiangUploadSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M4 2H22L30 10V28C30 29.1046 29.1046 30 28 30H4C2.8954 30 2 29.1046 2 28V4C2 2.8954 2.8954 2 4 2Z"
        fill="#5AD9FF"
      />
      <path
        d="M19.1818 16.25L22.4992 13.9688C22.5964 13.9018 22.7235 13.8936 22.8288 13.9475C22.9341 14.0014 23 14.1084 23 14.225V21.775C23 21.8916 22.9341 21.9986 22.8288 22.0525C22.7235 22.1064 22.5964 22.0982 22.4992 22.0312L19.1818 19.75V22.375C19.1818 22.7202 18.8969 23 18.5455 23H9.63636C9.2849 23 9 22.7202 9 22.375V13.625C9 13.2798 9.2849 13 9.63636 13H18.5455C18.8969 13 19.1818 13.2798 19.1818 13.625V16.25ZM11 17V19H13V17H11Z"
        fill="white"
      />
      <path d="M22 2L30 10H24C22.8954 10 22 9.1046 22 8V2Z" fill="#BCEFFF" />
    </svg>
  )
}

export { MentINputDiffSVG, SendBsSendBtnSVG, UploadFileDefSVG, UploadImgDefSVG, WanxiangUploadSVG }
